const pageData = [
  {
    order: 1,
    title: "Lagspelare",
    heading: "Lagspelare",
    subheading: "Alla kan inte vara Zlatan.",
    dl1: "Ibland betyder lagspelare bara att man ska jobba i ett team.",
    dl2:
      "Alla i ett lag har olika positioner. En målvakt och en anfallare har inte samma uppgifter på planen.",
    navTitle: "",
    link: "/lagspelare/"
  },
  {
    order: 2,
    title: "Quiz",
    heading: "Lagspelare",
    subheading: "Metaforer kan uppfattas olika och vara svåra att förstå.",
    link: "/lagspelare/02/",
    quizHeading: "Hur är en lagspelare på din arbetsplats?",
    quizAnswer1: {
      content: "Får personer av olika ståndpunkt att komma överens",
      note: "Relationskompetens"
    },
    quizAnswer2: {
      content: "Handlar konstruktivt vid motgångar",
      note: "Anpassningskompetens"
    },
    quizAnswer3: {
      content: "Arbetar med andra för att gemensamt lösa en uppgift",
      note: "Relationskompetens"
    },
    quizAnswer4: {
      content: "Bygger upp och stärker relationer",
      note: "Relationskompetens"
    },
    modal: {
      heading: "Lagspelare",
      subheading: "Grattis!",
      body:
        "Nu har du ökat möjligheten att hitta din organisations egna stjärnspelare.",
      buttonText: "Fortsätt jakten!"
    }
  }
];

export default pageData;



// WEBPACK FOOTER //
// ./src/data/lagspelare.js